<template>
  <section
    id="system-modal"
    class="vn-modal vn-modal--md vn-modal--system"
    :class="{ 'vn-modal--invert': !isDark }"
    v-if="showModal"
    @click="closeModal"
  >
    <div class="vn-modal__box" @click.stop>
      <h2 class="vn-modal__h">{{ title }}</h2>
      <p class="vn-modal__p">{{ message }}</p>

      <div class="vn-modal__cont">
        <icon-error-system />
      </div>

      <div class="vn-modal__func btn__flex" v-if="confirm">
        <button @click="closeModal" class="btn btn--md" type="button">확인</button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import IconErrorSystem from '../icons/error-system.vue';

export default {
  name: 'system-modal-view',
  components: {
    IconErrorSystem,
  },
  computed: {
    ...mapState(['systemModalContent']),
    showModal() {
      return this.systemModalContent && (this.systemModalContent.title || this.systemModalContent.message);
    },
    isDark() {
      return this.systemModalContent.isDark;
    },
    title() {
      return this.systemModalContent.title;
    },
    message() {
      return this.systemModalContent.message;
    },
    confirm() {
      return this.systemModalContent.confirm;
    },
  },
  methods: {
    ...mapActions(['clearSystemModalContent']),
    closeModal() {
      this.clearSystemModalContent();
    },
  },
};
</script>

<style scoped lang="scss">
#system-modal {
  z-index: 999;
}
</style>
